module.exports = __webpack_public_path__ + "img/normaldance.d6c2183c.png";